// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #0066CC;
  --secondary-color: #00A3E0;
  --dark-color: #1A1A1A;
  --light-color: #F8FAFC;
  --text-color: #2D3748;
  --text-light: #64748B;
  --white: #FFFFFF;
  --accent-color: #EF4444;
  --success-color: #10B981;
  --border-color: #E2E8F0;
  
  --font-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'Helvetica Neue', sans-serif;
  --font-secondary: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
  
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

body {
  font-family: var(--font-primary);
  color: var(--text-color);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

html {
  scroll-behavior: smooth;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-secondary);
  font-weight: 600;
  line-height: 1.2;
  color: var(--dark-color);
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  font-family: var(--font-primary);
  cursor: pointer;
  border: none;
  outline: none;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

.container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

.section {
  padding: 96px 0;
}

@media (max-width: 768px) {
  .section {
    padding: 64px 0;
  }
  
  .container {
    padding: 0 20px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;;EAEvB,oGAAoG;EACpG,oFAAoF;;EAEpF,mDAAmD;EACnD,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;AACxF;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --primary-color: #0066CC;\n  --secondary-color: #00A3E0;\n  --dark-color: #1A1A1A;\n  --light-color: #F8FAFC;\n  --text-color: #2D3748;\n  --text-light: #64748B;\n  --white: #FFFFFF;\n  --accent-color: #EF4444;\n  --success-color: #10B981;\n  --border-color: #E2E8F0;\n  \n  --font-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'Helvetica Neue', sans-serif;\n  --font-secondary: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;\n  \n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\nbody {\n  font-family: var(--font-primary);\n  color: var(--text-color);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-secondary);\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--dark-color);\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  font-family: var(--font-primary);\n  cursor: pointer;\n  border: none;\n  outline: none;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.container {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.section {\n  padding: 96px 0;\n}\n\n@media (max-width: 768px) {\n  .section {\n    padding: 64px 0;\n  }\n  \n  .container {\n    padding: 0 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
